import { Link } from 'react-router-dom';
import { StrategicList } from '../WatchlistDashboardService';
import AlumniRow from './AlumniRow';
import { buildReportLink } from '../reportLink';

// Strategy → badge colour (matches the HTML mockup intent colours).
const STRATEGY_TONE: Record<string, string> = {
    'Defend & Deepen': 'bg-primary',
    Grow: 'bg-success',
    'Open New': 'bg-bs-purple bg-opacity-100',
    'Re-Engage': 'bg-warning',
};

/**
 * Layer 2 Strategic watchlist card. `card` is a list result (total = card count, alumni = top N).
 */
const StrategicCard = ({ card, instituteId, filterInstituteId }: { card: StrategicList; instituteId: string | number; filterInstituteId?: string | null }) => (
    <div className="col">
        <div className="border rounded-4 p-4 h-100 d-flex flex-column justify-content-between bg-purple-f5f3ff border-bs-purple border-opacity-10 shadow-sm">
            <div>
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <span className={`badge py-2 px-3 text-uppercase font-12 font-600 text-white rounded-1 ${STRATEGY_TONE[card.strategy] || 'bg-secondary'}`}>
                        {card.strategy}
                    </span>
                    <div className="text-end">
                        <div className="font-22 font-600 text-dark">{card.total}</div>
                        <div className="font-12 text-secondary">alumni</div>
                    </div>
                </div>
                <div className="font-13 font-600 text-dark-blue mb-1">{card.label}</div>
                <div className="font-12 text-secondary-emphasis mb-3">{card.description}</div>

                <hr />
                <div className="font-12 font-600 text-uppercase text-muted mb-2">Top Alumni</div>
                <div className="d-flex flex-column gap-1">
                    {card.alumni.length === 0 ? (
                        <div className="font-12 text-muted">No alumni in this watchlist yet</div>
                    ) : (
                        card.alumni.map((alumni) => <AlumniRow key={alumni.student_id} alumni={alumni} />)
                    )}
                </div>
            </div>
            {card.total > 0 && (
                <Link
                    to={buildReportLink({ institute_id: instituteId, filter_institute_id: filterInstituteId, layer: 'strategic', watchlist_code: card.watchlist_code, outcome: card.outcome })}
                    className="d-inline-flex align-items-center gap-1 mt-3 font-12 font-600 text-primary text-decoration-none">
                    View All {card.total} <i className="bi bi-arrow-right"></i>
                </Link>
            )}
        </div>
    </div>
);

export default StrategicCard;
